<template>
  <main class="text-center text-white relative pt-16 sm:pt-8" id="contact">
    <Teleport to="body">
      <NoticeView v-if="open" @close="open = false" />
    </Teleport>

    <Teleport to="body">
      <div v-if="done" class="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999]">
        <div class="bg-[#1a1a2e] border-2 border-yellow-500 rounded-lg p-8 mx-4 max-w-md text-center">
          <h2 class="text-2xl font-veneer text-yellow-500 mb-4">Message envoyé !</h2>
          <p class="text-white mb-6">Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.</p>
          <span @click="done = false" class="btn font-veneer !px-8 cursor-pointer">Fermer</span>
        </div>
      </div>
    </Teleport>

    <img
      src="../assets/images/pepite1.png"
      class="sm:hidden w-[15vw] absolute top-[45px] -right-[3vw] rotate-[270deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[5vw] absolute top-[165px] left-[3vw] rotate-[20deg] z-50"
      style="align-items: center"
    />

    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute top-[395px] -left-[10px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute bottom-[15px] right-[20px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[4vw] absolute -bottom-[20px] right-[15px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <div
      class="ombre2 top-48 opacity-40 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute aspect-square max-w-4xl w-full m-auto"
    ></div>
    <div class="relative z-40">
      <h1 class="text-white text-4xl font-veneer mb-6">CONTACT</h1>
      <form class="relative z-50 px-[10vw] sm:px-8">
        <div class="form-item">
          <label>Votre nom*</label>
          <input
            @input="error.lastname = ''"
            :disabled="loadingState"
            required
            v-model="form.lastname"
            id="lastname"
            type="text"
          />
          <span v-if="error.lastname" class="error">*{{ error.lastname }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Votre prénom*</label>
          <input
            @input="error.firstname = ''"
            :disabled="loadingState"
            required
            v-model="form.firstname"
            id="firstname"
            type="text"
          />
          <span v-if="error.firstname" class="error"
            >*{{ error.firstname }}</span
          >
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Votre adresse email*</label>
          <input
            @input="error.email = ''"
            :disabled="loadingState"
            required
            v-model="form.email"
            class="w-full"
            id="email"
            type="email"
          />
          <span v-if="error.email" class="error">*{{ error.email }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Type de demande*</label>
          <select
            :disabled="loadingState"
            required
            id="status"
            name="contact[statut]"
            class="form-control form-control"
            v-model="form.objet"
          >
            <option value="" disabled selected>Choisissez une option</option>

            <option>Problème technique lors de ma participation</option>
            <option>Je n'arrive pas à télécharger mes preuves d'achat</option>
            <option>Le site de l'offre ne fonctionne pas</option>
            <option>
              Je n'arrive pas à suivre le traitement de mon dossier de
              participation
            </option>
            <option>
              Le lien de suivi de ma participation ne fonctionne pas
            </option>
            <option>Le montant de mon remboursement n'est pas correct</option>
            <option>Demande d'information sur l'offre</option>
            <option>
              Mon ou mes produit(s) est (sont)-il(s) éligible(s) à l'offre?
            </option>
            <option>Autre</option>
          </select>
          <span v-if="error.objet" class="error">*{{ error.objet }}</span>
        </div>
        <div class="form-item">
          <label class="sm:-mt-2">Objet*</label>
          <input
            @input="error.object = ''"
            :disabled="loadingState"
            required
            v-model="form.object"
            id="object"
            type="text"
          />
          <span v-if="error.object" class="error">*{{ error.object }}</span>
        </div>
        <div class="form-item">
          <label>Message*</label>
          <textarea
            @input="error.message = ''"
            id="contact_message"
            name="message"
            required="required"
            class="form-control form-control h-36"
            v-model="form.message"
          ></textarea>
          <span v-if="error.message" class="error">*{{ error.message }}</span>
        </div>
        <div class="text-xs italic text-left md:-mt-4">
          *Champs obligatoires
        </div>
        <p class="text-xs mt-4 italic text-justify">
          Ferrero France commerciale traite les données recueillies sur la base
          de votre consentement pour gérer votre participation à ce jeu.
          Pour en savoir plus sur la gestion de vos données
          personnelles et pour exercer vos droits, reportez-vous à la
          <a class="underline cursor-pointer" @click="open = true"
            >notice ci-jointe</a
          >.
        </p>
      </form>
      <div class="w-full text-center">
        <span
          v-if="!loadingState"
          @click.prevent="getResult"
          class="btn block m-auto my-6 font-veneer !px-16"
          >envoyer</span
        >
        <span
          v-if="loadingState"
          class="btn block !bg-gray-100 !text-gray-500 m-auto my-6 font-veneer !px-16"
          >Chargement...</span
        >
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import NoticeView from "@/components/NoticeView.vue";
import Teleport from "vue2-teleport";
export default {
  data: function () {
    return {
      error: {},
      open: false,
      loadingState: false,
      required_field: ["lastname", "firstname", "objet", "object", "email", "message"],
      operationId: "6ab5213da6298f733bc73670",
      idgame: "2025-Agence TMS-292",
      subid: "",
      uid: "",
      done: false,
      form: {
        objet: "",
        operation: undefined,
        youare: "Particulier",
        civilite: "MR",
        addr: {},
      },
    };
  },
  components: {
    NoticeView,
    Teleport,
  },
  async mounted() {
    try {
      this.operationId = "6ab5213da6298f733bc73670";
      this.idgame = "2025-Agence TMS-292";
      this.subid = sessionStorage.getItem("subid") || null;
      this.uid = sessionStorage.getItem("subid") || null;

      this.scrollToTop();

      if (this.subid != null && this.uid != null) {
        let { data: submission } = await axios.get(
          `${process.env.VUE_APP_ROOT_API}/api/v2/submissions/${this.subid}?uid=${this.uid}`
        );

        if (submission) {
          this.form = {
            society: "",
            subid: this.subid,
            operationId: this.operationId,
            lastname: submission.last_name,
            firstname: submission.first_name,
            email: submission.email,
            email_confirmation: submission.email,
          };
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isRequired(value) {
      return value ? true : "Ce champ est requis";
    },
    getResult() {
      try {
        this.loadingState = true;
        let error = 0;

        for (let key of this.required_field) {
          if (!this.form[key] || this.form[key] == "") {
            this.error[key] = "Ce champ est requis";
            error++;
          }
        }
        if (error > 0) {
          this.loadingState = false;
          return;
        }

        let id = sessionStorage.getItem("_id");

        if (id == null) id = "n/a";

        if (error === 0) {
          var formDatas = {
            civilite: "Mr",
            operationId: this.operationId,
            nom: this.form.lastname,
            prenom: this.form.firstname,
            email: this.form.email,
            subid: this.subid,
            society: this.form.society,
            demande: this.idgame,
            objet: this.form.objet,
            message: this.form.message,
            idgame: this.idgame,
            type: "plateforme",
          };
          axios
            .post(
              `https://api-gabarit.promo.dev/api/operations-custom/promodev-send-contact/sendmail`,
              formDatas
            )
            .then(() => {
              this.loadingState = false;
              this.dialogState = true;
              this.form = {};
              this.done = true;
            })
            .catch((err) => {
              console.error("Erreur envoi contact:", err);
              this.loadingState = false;
            });
        } else {
          this.loadingState = false;
        }
      } catch (e) {
        console.log(e);
        this.loadingState = false;
      }
    },
  },
};
</script>
<style scoped>
.ombre2 {
  background-image: url("@/assets/images/flou-min.png");
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.error {
  @apply text-yellow-200 w-full text-sm block text-left my-1 p-0;
}
</style>
